import * as React from 'react';
import { tokens } from '@fluentui/react-components';
import { AttachmentDetails } from '../hooks/client/types/CreateEmailObjectRequest';
import Attachment from './icons/Attachment';
import { useFileSize } from '../hooks/useFileSize';
import { CustomCard, CustomCardProps } from './CustomCard';

type AttachmentCardProps = Omit<CustomCardProps, 'caption' | 'header' | 'icon'> & {
  attachment: AttachmentDetails;
};

export const AttachmentCard = ({ attachment, ...rest }: AttachmentCardProps) => {
  const { fileName, size } = attachment;

  const format = useFileSize();
  const formattedSize = format(size);

  return (
    <CustomCard
      header={fileName}
      caption={formattedSize}
      icon={<Attachment fill={tokens.colorBrandBackground} />}
      {...rest}
    />
  );
};
